import { Routes, Route, Navigate } from "react-router-dom";
import { lazy } from "react";

const Dashboard = lazy(() => import("../screens/SuperAdminRole/Dashboard"));
const Clinics = lazy(() => import("../screens/SuperAdminRole/Clinics"));
const Appointments = lazy(() =>
  import("../screens/SuperAdminRole/Appointments")
);

export default function SuperAdminRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="clinics" element={<Clinics />} />
      <Route path="appointments" element={<Appointments />} />
      <Route path="*" element={<Navigate to="/superadmin" replace />} />
    </Routes>
  );
}
